import React from 'react';

export default class CabinetLogin extends React.Component {
  componentDidMount() {
    document.getElementById('scroll-case').parentNode.scrollTop = 0;
  }
  
  render() {
    return (
      <div className="cabinet-file-content">
        <div className="login-wrapper">
          <div className="form-wrapper">
            <form action="/login" method="post">
              <div className="form-group">
                <label>Username</label>
                <input name="name" type="text" placeholder="_"/>
              </div>
              <div className="form-group">
                <label>Password</label>
                <input name="password" type="password" placeholder="*"/>
              </div>
              <button type="submit">Log in</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/CabinetLogin.jsx